import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Text, ScrollView } from 'react-native';
import { TodoManagement } from '@cubemeet/ui';
import { useTodoI18n } from './useTodoI18n';
import { MODULE_COLORS } from '@cubemeet/core/theme';

// 模拟数据 - 实际项目中应该从API获取
const mockTodos = [
  {
    id: '1',
    title: '准备行李',
    description: '整理旅行必需品，检查护照有效期',
    completed: false,
    creator: { display_name: 'Cube Meet' },
    created_at: '2025-10-10T08:00:00Z',
  },
  {
    id: '2',
    title: '预订酒店',
    description: '确认住宿安排',
    completed: true,
    creator: { display_name: 'Alice' },
    created_at: '2025-10-09T14:30:00Z',
  },
  {
    id: '3',
    title: '购买保险',
    description: '为旅行购买合适的保险',
    completed: false,
    creator: { display_name: 'Bob' },
    created_at: '2025-10-08T10:15:00Z',
  },
];

const TodoListModule: React.FC = () => {
  const { t } = useTodoI18n();
  const [todos, setTodos] = useState(mockTodos);

  const handleAddTodo = () => {
    // 添加新的待办事项
    const newTodo = {
      id: `todo-${Date.now()}`,
      title: `新待办事项 ${todos.length + 1}`,
      description: '点击编辑描述',
      completed: false,
      creator: { display_name: 'Current User' },
      created_at: new Date().toISOString(),
    };
    
    setTodos(prevTodos => [newTodo, ...prevTodos]);
    console.log('添加待办事项:', newTodo);
  };

  const handleToggleTodo = (todoId: string, completed: boolean) => {
    // TODO: 实现切换待办事项状态的逻辑
    setTodos(prevTodos =>
      prevTodos.map(todo =>
        todo.id === todoId ? { ...todo, completed } : todo
      )
    );
    console.log(`待办事项 ${todoId} 状态切换为: ${completed}`);
  };

  const handleTodoPress = (todoId: string) => {
    // TODO: 实现点击待办事项的逻辑（编辑/详情）
    console.log(`点击待办事项: ${todoId}`);
  };

  return (
    <View style={styles.container}>
      <ScrollView style={styles.scrollView} contentContainerStyle={styles.content}>
        <View style={styles.header}>
          <Text style={styles.title}>{t('todo.categories.title') || '待办事项'}</Text>
          <Text style={styles.subtitle}>管理您的任务和目标</Text>
        </View>

        <TodoManagement
          todos={todos}
          canAddTodo={true}
          onAddTodo={handleAddTodo}
          onToggleTodo={handleToggleTodo}
          t={t}
          style={styles.todoSection}
        />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  scrollView: {
    flex: 1,
  },
  content: {
    padding: 16,
  },
  header: {
    marginBottom: 24,
    alignItems: 'center',
  },
  title: {
    fontSize: 28,
    fontWeight: '700',
    color: MODULE_COLORS.todo,
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
  },
  todoSection: {
    marginBottom: 16,
  },
});

export default TodoListModule;